export type PaymentStatus = 'draft' | 'pending_admin_approval' | 'approved' | 'rejected' | 'submitted_to_reap' | 'processing' | 'completed' | 'failed';

export type DocumentStatus = 'pending' | 'approved' | 'rejected';

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  draft: 'Draft',
  pending_admin_approval: 'Waiting Admin Approval',
  approved: 'Approved',
  rejected: 'Rejected',
  submitted_to_reap: 'Processing',
  processing: 'Processing Payment',
  completed: 'Completed',
  failed: 'Failed',
};

export const DOCUMENT_STATUS_LABELS: Record<DocumentStatus, string> = {
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
};

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  draft: '#6c757d', // gray
  pending_admin_approval: '#ffc107', // yellow
  approved: '#28a745', // green
  rejected: '#dc3545', // red
  submitted_to_reap: '#6610f2', // purple
  processing: '#17a2b8', // cyan
  completed: '#007bff', // blue
  failed: '#dc3545', // red
};

export const DOCUMENT_STATUS_COLORS: Record<DocumentStatus, string> = {
  pending: '#ffc107', // yellow
  approved: '#28a745', // green
  rejected: '#dc3545', // red
};
